<template>
  <div class="container">
    <div class="count-down">
      <div class="fz-32" style="color:#FF8C00">{{countDownLatch}}s</div>
      <!--<van-circle-->
        <!--size="50"-->
        <!--stroke-width="3"-->
        <!--speed="300"-->
        <!--value="{{countDownPercent}}"-->
        <!--layer-color="#dddddd"-->
        <!--color="#FF8C00"-->
        <!--clockwise="{{ false }}">-->
        <!--<text class="fz-32" style="color:#FF8C00" slots="text">{{countDownLatch}}s</text>-->
      <!--</van-circle>-->
    </div>
    <div class="selfInfo1" style="width: 100%;padding: 0">
      <img class="guizi" src="../assets/images/img-guizi@2x.png" style="width:1.56rem"/>
      <div class="fz-32" style="margin: .55rem 0 .2rem 0;padding: 0 .5rem">
        <img class="dingwei" src="../assets/images/icon-dingwei@2x.png"/>
        {{orderInfo.orderPickUpInfoBean.deviceName}}
      </div>
      <div class="cell-no">
        <div class="no" style="font-size: 1.2rem">
          {{orderInfo.orderPickUpInfoBean.cellNo}}
        </div>
      </div>
      <div class="fz-32" style="margin-top: .4rem">箱门已打开</div>
      <div class="fz-32" style="margin-bottom: .4rem">请取走您的餐盒并关好箱门</div>
      <div class="btn-open fz-32" style="height:1rem;line-height:1rem" @click="closePage">确认已取，并关好箱门</div>
      <div class="fz-30" style="color:#4A90E2;margin-top: .4rem" @click="sureCabinet">箱门未开，重试箱门</div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  export default {
    name: "deviceDetail",
    data () {
      return {
        orderInfo: {},
        orderId: '',
        countDownLatch: '',
        timer: '',
        countDownPercent: 100
      }
    },
    created () {
      this.orderId = this.$route.params.id;
      this.getOrderDetail()
    },
    methods: {
      getOrderDetail () {
        var _this = this
        var param = {
          order_id: _this.orderId
        }
        actions.getOrderDetail(_this, param, function (data) {
          _this.orderInfo = data;
          _this.countDownLatch = data.orderPickUpInfoBean.countDownLatch;
          _this.countDownFn();
        })
      },
      countDownFn() {
        let countDownLatch = this.countDownLatch; // 获取倒计时初始值
        this.timer = setInterval(() => {
          countDownLatch--;
          this.countDownLatch = countDownLatch;
          // this.countDownPercent = (countDownLatch/this.data.orderInfo.orderPickUpInfoBean.countDownLatch)*100
          if (countDownLatch == 0) {
            clearInterval(this.timer);
            // wx.navigateBack();
            this.$router.back()
          }
        }, 1000)
      },
      // 一键开柜
      sureCabinet() {
        var _this = this
        let params = {
          operateType: 1,
          order_id: _this.orderId
        }
        _this.$indicator.open();
        actions.openCabinet(_this, params, function (data) {
          _this.$indicator.close();
          _this.$toast('开柜成功 请取走您的餐盒并关好箱门');
        }, function (data) {
          _this.$indicator.close();
          _this.$toast(data.data.message);
        })
      },
      closePage() {
        this.$router.back()
      }
    }
  }
</script>

<style scoped>
  .container{
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 0 .3rem;
    margin: 0 auto;
    text-align: center;
  }
  .selfInfo1 .guizi{
    margin: 0 auto;
  }
  .count-down{
    position: absolute;
    top: .3rem;
    right: .3rem;
  }
</style>



// WEBPACK FOOTER //
// DeviceDetail.vue?6f5f83bc